import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { DocumentService } from '@src/core/services';

@Component({
  selector: 'app-term-of-the-privacy',
  templateUrl: './term-of-the-privacy.component.html',
  styleUrls: ['./term-of-the-privacy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermOfThePrivacyComponent {
  private readonly documentService = inject(DocumentService);

  @Input() associationId?: string;

  onClickPolicyLink() {
    if (!this.associationId) return;

    this.documentService.downloadAssociationPolicy(this.associationId);
  }
}
